// extracted by mini-css-extract-plugin
module.exports = {"screenReader":"Text__screenReader___29PiG"};